import React, { useState } from 'react';
import { MonthYear, adjustMonthYear, monthYearToString } from '../../../../utils/MonthYear/monthYear';
import DateValueInputMultiChart, { DateValueChartProps } from './DateValueInputMultiChart';
import { SwitchDates } from './SwitchDatesChevron';
import { MonthYearValue } from '../../../../utils/MonthYear/MonthYearValue';
import { getDateAfter, isBefore } from '../../../../pages/FutureOrder/futureOrderUtils';
import { ToggleChips } from '../../../../pages/Dashboard/dashboard-components/ToggleChips';
import { CalendarTodayOutlined } from '@mui/icons-material';

const FILTER_OPTIONS = [
  { key: 'Year View', value: 12 },
  { key: '2 Years view', value: 24 },
];
export const DateValueInputWithDateSwitch: React.FC<DateValueChartProps> = ({
  mainChart,
  isHideValueInput,
  numberOfMonthsToShow,
  changeMonths,
  startingDate,
  endDate,
  updateEditablePropertyFunc,
  suggestedMaxValue,
  suggestedMinValue,
  additionalCharts,
}) => {
  const [currentStartingDate, setCurrentStartingDate] = useState<MonthYear>(
    startingDate || { month: 1, year: new Date().getFullYear() },
  );
  const [showMonthCount, setShowMonthCount] = useState(numberOfMonthsToShow);

  const goForward = () => setCurrentStartingDate(adjustMonthYear(currentStartingDate, changeMonths));
  const goBack = () => setCurrentStartingDate(adjustMonthYear(currentStartingDate, -changeMonths));

  const showGoLeft = (startingDate: MonthYear, mainData: MonthYearValue[]): boolean => {
    return !!mainData?.[0]?.date && isBefore(mainData[0].date, startingDate);
  };

  const showGoRight = (startingDate: MonthYear, showMonths: number, dataEndDate?: MonthYear): boolean => {
    return !!dataEndDate && isBefore(getDateAfter(startingDate, showMonths), dataEndDate);
  };

  return (
    <div className="flex flex-col flex-1 min-h-72 w-full overflow-hidden">
      <div className="flex flex-1 -mb-2 z-10">
        <div className="flex flex-1"></div>
        <div>
          <SwitchDates
            text={
              monthYearToString(currentStartingDate) +
              ' - ' +
              monthYearToString(adjustMonthYear(currentStartingDate, showMonthCount - 1))
            }
            onPressLeft={goBack}
            onPressRight={goForward}
            showLeft={showGoLeft(currentStartingDate, mainChart.data)}
            showRight={showGoRight(currentStartingDate, showMonthCount, endDate)}
          />
        </div>
        <div className="flex flex-[0.5]"></div>
        <div className="flex gap-3  justify-end w-40">
          <ToggleChips
            chips={FILTER_OPTIONS}
            selected={showMonthCount}
            setSelected={setShowMonthCount}
            width="6rem"
            variant="outlined"
          >
            <div className="w-8 h-6 flex items-center justify-center text-gray-600">
              <CalendarTodayOutlined fontSize="small" />
            </div>
          </ToggleChips>
        </div>
      </div>
      <DateValueInputMultiChart
        suggestedMaxValue={suggestedMaxValue}
        suggestedMinValue={suggestedMinValue}
        mainChart={mainChart}
        isHideValueInput={isHideValueInput}
        numberOfMonthsToShow={showMonthCount}
        changeMonths={changeMonths}
        startingDate={currentStartingDate}
        endDate={endDate}
        goForward={goForward}
        goBack={goBack}
        updateEditablePropertyFunc={updateEditablePropertyFunc}
        additionalCharts={additionalCharts}
      />
    </div>
  );
};
